import { useEffect, useRef } from 'react';
import { useIntercom } from 'react-use-intercom';

const INTERCOM_ARTICLE_ID = 12889423;

interface IntercomHandlerProps {
  children: React.ReactNode;
}

/**
 * Handles Intercom messenger events.
 * Automatically displays article 12889423 when the messenger opens.
 */
function IntercomHandler({ children }: IntercomHandlerProps) {
  const { showArticle } = useIntercom();
  const showArticleRef = useRef(showArticle);

  // Keep ref updated with latest function to avoid stale closures
  useEffect(() => {
    showArticleRef.current = showArticle;
  }, [showArticle]);

  useEffect(() => {
    if (!window.Intercom) {
      return;
    }

    const handleIntercomShow = () => {
      try {
        showArticleRef.current(INTERCOM_ARTICLE_ID);
      } catch (error) {
        console.error(`Failed to show Intercom article ${INTERCOM_ARTICLE_ID}:`, error);
      }
    };

    try {
      window.Intercom('onShow', handleIntercomShow);
    } catch (error) {
      console.error('Failed to register Intercom onShow listener:', error);
    }
  }, []);

  return <>{children}</>;
}

export default IntercomHandler;
